import React from 'react'

import { Status } from '../../../api/services/orders/types.ts'
import { convertOrderStatus } from '../../../utils/formatter.ts'
import { BadgeProps } from './Badge.types.ts'

const Badge: React.FC<BadgeProps> = ({ status }) => {
  const getStyles = (status: Status) => {
    switch (status) {
      case 'done':
        return 'bg-success text-success'
      case 'not_paid':
        return 'bg-danger text-danger'
      case 'waiting_for_realization':
        return 'bg-warning text-warning'
      case 'change_requested':
        return 'bg-[#03fcec] dark:bg-[#d4cc35] text-[#2d7570]'
      case 'in_progress':
        return 'bg-primary text-primary'
      case 'canceled':
        return 'bg-gray-800 text-red-500 line-through border-b-2 border-red-500'
      default:
        return 'bg-gray-100 text-gray-500'
    }
  }

  return (
    <p
      className={`inline-flex max-w-full min-w-0 rounded-xl bg-opacity-20 py-2 px-3 text-sm ${getStyles(
        status
      )}`}
      title={convertOrderStatus(status)}
    >
      <span className="truncate">{convertOrderStatus(status)}</span>
    </p>
  )
}

export default Badge
